import React from 'react';

import ToggleGroup, {
  ToggleGroupProps
} from '@terrestris/react-geo/dist/Button/ToggleGroup/ToggleGroup';

import {
  useAppDispatch
} from '../../hooks/useAppDispatch';
import {
  useAppSelector
} from '../../hooks/useAppSelector';
import {
  setActiveTool
} from '../../store/activeTool';
import {
  toggleVisibility
} from '../../store/drawer';

import PrintButton from '../PrintButton';
import ToggleFeatureInfoButton from '../ToggleFeatureInfoButton';
import ToggleLayerTreeButton from '../ToggleLayerTreeButton';

import './index.less';

export type MapToolbarProps = Partial<ToggleGroupProps>;

export const MapToolbar: React.FC<Partial<MapToolbarProps>> = ({
  ...passThroughProps
}): JSX.Element => {

  const isDrawerOpen = useAppSelector(state => state.drawer.visible);
  const activeTool = useAppSelector(state => state.activeTool);

  const dispatch = useAppDispatch();

  const onToogleGroupChange = (childProps: any) => {
    if (!isDrawerOpen) {
      dispatch(setActiveTool(childProps.name));
      dispatch(toggleVisibility());
    }

    if (isDrawerOpen) {
      if (childProps.pressed) {
        dispatch(toggleVisibility());
        dispatch(setActiveTool(null));
      } else {
        dispatch(setActiveTool(childProps.name));
      }
    }
  };

  return (
    <div
      className="map-toolbar"
    >
      <PrintButton />
      <ToggleGroup
        orientation="horizontal"
        allowDeselect={true}
        onChange={onToogleGroupChange}
        selectedName={activeTool ? activeTool : undefined}
        {...passThroughProps}
      >
        <ToggleFeatureInfoButton
          name='feature-info'
        />
        <ToggleLayerTreeButton
          name='layer-tree'
        />
      </ToggleGroup>
    </div>
  );
};

export default MapToolbar;
